<template>
  <div class="report-chapter-title" :style="backgroundStyle">
    <span>{{ title }}</span>
  </div>
</template>

<script>
import { REPORT_ASSETS } from '../reportAssets';

export default {
  name: 'ReportChapterTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: ['url("', REPORT_ASSETS.chapterTitle, '")'].join(''),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.report-chapter-title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44%;
  aspect-ratio: 957 / 247;
  margin: 1.4% auto 2.4%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #68311d;
  font-size: 21px;
  line-height: 1;
  font-weight: 700;
  text-align: center;
  text-shadow: 0 1px 2px rgba(98, 48, 12, 0.45);
  break-after: avoid;
  page-break-after: avoid;
}

.report-chapter-title span {
  position: relative;
  z-index: 1;
  transform: translateY(-2%);
  white-space: nowrap;
}
</style>
